// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__rgeLU","title":"InfoRow_title__2LM58"};